import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Select,
  Input,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import assetsService from "../../services/rentals/assetsService";
import reservationsService from "../../services/rentals/reservationsService";

export default function ReservationFlow() {
  const [assets, setAssets] = useState([]);
  const [form, setForm] = useState({
    assetId: "",
    fromDate: "",
    toDate: "",
    notes: "",
  });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function loadAssets() {
      try {
        const res = await assetsService.listAssets();
        setAssets(res.items || res || []);
      } catch (e) {
        console.error(e);
      }
    }
    loadAssets();
  }, []);

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const payload = {
        assetId: form.assetId,
        fromDate: form.fromDate,
        toDate: form.toDate,
        notes: form.notes,
      };
      const res = await reservationsService.createReservation(payload);
      navigate(`/rentals/reservations/${res._id}`);
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <FormControl mb={3}>
        <FormLabel>Asset</FormLabel>
        <Select
          value={form.assetId}
          onChange={(e) => setForm({ ...form, assetId: e.target.value })}
        >
          <option value="">Select asset</option>
          {assets.map((a) => (
            <option key={a._id} value={a._id}>
              {a.name}
            </option>
          ))}
        </Select>
      </FormControl>

      <FormControl mb={3}>
        <FormLabel>From</FormLabel>
        <Input
          type="date"
          value={form.fromDate}
          onChange={(e) => setForm({ ...form, fromDate: e.target.value })}
        />
      </FormControl>

      <FormControl mb={3}>
        <FormLabel>To</FormLabel>
        <Input
          type="date"
          value={form.toDate}
          onChange={(e) => setForm({ ...form, toDate: e.target.value })}
        />
      </FormControl>

      <FormControl mb={4}>
        <FormLabel>Notes</FormLabel>
        <Input
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
        />
      </FormControl>

      <Button colorScheme="teal" onClick={handleSubmit} isLoading={saving}>
        Create reservation
      </Button>
      <Text fontSize="12px" color="gray.500" mt={3}>
        Note: availability checks should be validated server-side.
      </Text>
    </Box>
  );
}
